<script lang="ts">
	import MessagesNavIcon from '$lib/features/messages/components/MessagesNavIcon.svelte';
	import { seller_state } from '$lib/features/profile/states/seller_state';
	import { page } from '$app/state';

	const titles = {
		'/': 'home',
		'/shipments': 'shipments',
		'/pickups': 'pickups',
		'/products': 'products',
		'/invoices': 'invoices',
		'/profile': 'profile'
	} as const;

	const title = $derived(
		page.url.pathname === '/'
			? seller_state.value?.name || ''
			: (titles[page.url.pathname as keyof typeof titles] ?? '')
	);
</script>

<header class="sticky top-0 z-[90] w-full border-b border-border bg-background/90 backdrop-blur-sm">
	<div class="mx-auto flex h-14 w-full max-w-[672px] items-center justify-between px-3 sm:px-4 lg:max-w-[1100px]">
		<div class="flex min-w-0 items-center gap-2">
			<h1 class="text-signboard truncate text-lg sm:text-xl">{title}</h1>
		</div>
		<div class="flex items-center gap-1">
			<MessagesNavIcon own_user={{ role: 'seller', value: seller_state.value }} />
		</div>
	</div>
</header>
